"use client";

import { cn, Table } from "@kyan/ui";

import { EmptyState } from "#/components/Contents/components/EmptyState/EmptyState";
import { usePositionsDrawerMarket } from "#/store/app/positionsDrawer/positionsDrawerMarket";
import { useOpenOrders } from "#/store/wallet/account/openOrders";

import { columns } from "./PerpOpenOrders.constants";

export interface PerpOpenOrdersProps {
  isAllVariant?: boolean;
  isPortfolioVariant?: boolean;
}

export const PerpOpenOrders: React.FC<PerpOpenOrdersProps> = ({
  isAllVariant,
  isPortfolioVariant,
}) => {
  const { market } = usePositionsDrawerMarket();
  const { perpOpenOrders } = useOpenOrders();
  const isEmpty = !perpOpenOrders.length;

  return (
    <Table
      columns={columns}
      data={perpOpenOrders}
      hideHeader={isAllVariant}
      virtualization={
        isEmpty
          ? undefined
          : {
              estimateSize: 33,
              overscan: 12,
            }
      }
      emptyState={
        <EmptyState
          underlying={market.underlying}
          className="border-divider border-t"
          description={`Your open ${market.underlying} perp orders will show here`}
        />
      }
      classes={{
        wrapper: cn("bg-background", { "h-full": isEmpty }),
        table: cn({
          "border-b-0": isAllVariant || (isEmpty && !isPortfolioVariant),
          "flex h-full flex-col": isEmpty,
        }),
        thead: "bg-buttonBg",
        tbody: cn("text-textSecondary", {
          "min-h-40 flex-1": isEmpty,
        }),
        row: "bg-background",
        cellClassName: "py-1.5",
        loading: {
          skeleton: "h-3",
        },
      }}
    />
  );
};
